module.exports = __webpack_public_path__ + "img/E2 DB4.783ee215.png";